import { RootState } from "../../../app/rootReducer";
import { BookingType } from "../../Booking-Form/typings/booking-inputs";

export const selectConferenceZoneBookingEnabled = (state: RootState): boolean =>
  state.login.userInformation?.zoneTypes?.some(type => type.name === BookingType.CONFERENCEZONE) ??
  false;
